<template>
  <div
    id="app"
    class="text-support-500 antialiased"
    :class="[{'font-sans': !isRtl}, {'rtl-font': isRtl}]"
  >
    <nav-bar>
      <template v-slot:locale>
        <language-switcher></language-switcher>
      </template>
    </nav-bar>
    <router-view />

    <custom-footer />
    <transition name="fade-bottom">
      <div class="fixed inset-0 bg-white w-full h-full h-16 z-50 flex justify-center items-center" v-if="showUserMobileModal">
        <!-- <div class="absolute w-full h-full bg-gray-400 opacity-75"></div> -->
        <div class="container mx-auto">
          <button class="text-md font-semibold tracking-wide inline-block px-4 py-2 bg-white shadow rounded">Download app</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Cookie from "js-cookie";
import LanguageSwitcher from "@/components/LanguageSwitcher.vue";
import CustomFooter from "@/components/Footer";
import { mapGetters } from "vuex";

import NavBar from "@/components/NavBar";

export default {
  components: { LanguageSwitcher, NavBar, CustomFooter },
  data() {
    return {
      styleId: null,
      showUserMobileModal: false
    };
  },
  created() {
    const locale = Cookie.get("lang") || this.$i18n.locale;
     this.changeDocumentDirection(locale);
    this.$store.dispatch("locale/SET_LANGUAGE", locale);
  },
  watch: {
    "$i18n.locale": function($value) {
      this.changeDocumentDirection($value);
      this.routeTitle = this.$route.meta.pageTitle;
    }
  },
  methods: {
    changeDocumentDirection($value) {
      const dir = $value == "en" ? "ltr" : "rtl";
      document.documentElement.setAttribute("lang", $value);
      document.documentElement.setAttribute("dir", dir);
    }
  },
  computed: {
    ...mapGetters({
      isRtl: ["locale/IS_RTL"]
    })
  }
};
</script>

<style lang="scss">
// @font-face {
//   font-family: "IRANSans";
//   src: url("assets/fonts/IRANSans-Bold.woff2") format("woff2"),
//     url("assets/fonts/IRANSans-Bold.woff") format("woff");
//   font-weight: bold;
//   font-style: normal;
// }

// @font-face {
//   font-family: "IRANSans";
//   src: url("assets/fonts/IRANSans-Light.woff2") format("woff2"),
//     url("assets/fonts/IRANSans-Light.woff") format("woff");
//   font-weight: 300;
//   font-style: normal;
// }

@font-face {
    font-family: 'IRANSans';
    src: url('assets/fonts/NotoKufiArabic-Bold.woff2') format('woff2'),
        url('assets/fonts/NotoKufiArabic-Bold.woff') format('woff');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'IRANSans';
    src: url('assets/fonts/NotoKufiArabic.woff2') format('woff2'),
        url('assets/fonts/NotoKufiArabic.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}


.rtl-font {
  font-family: "IRANSans", "arial" !important;
  font-size: 14px;
  font-weight: light;
}
</style>
